 
const _ = require('lib/underscore')
const Radio = require('backbone.radio')
const log = require('log').create('radio') // eslint-disable-line

// add replies convenience method to all Radio Channels
Radio.Channel.prototype.requests = function requests() {
    // returns a list of available requests on this channel
    return _.keys(this._requests)
}
// add commands convenience method to all Radio Channels
Radio.Channel.prototype.commands = function commands() {
    // returns a list of available commands on this channel
    return _.keys(this._commands)
}

const radio = {}

const channels = [
    'abtest',
    'admin',
    'app',
    'auth',
    'dialog',
    'discover',
    'editpanel',
    'email_signature',
    'homepage',
    'metrics_discoverpage',
    'metrics_editpanel',
    'metrics_nav',
    'metrics_profile',
    'metrics_signup',
    'metrics_upgrade_modal',
    'metrics_upgrade_page',
    'metrics',
    'profile',
    'signup_buttons',
    'signup_finalize',
    'signup',
    'topnav',
    'upgrade',
    'viewer',
    'viewport',
]

channels.forEach(channel_name => {
    radio[channel_name] = Radio.channel(channel_name)
    radio[channel_name].on('all', function eventLogger(event_name, data) {
        const channel_log = require('log').create('radio', channel_name)
        channel_log.apply(channel_log, arguments)
    })
})

module.exports = radio
